// extracted by mini-css-extract-plugin
module.exports = {"container":"_3oq5vcpbuhDAXiPq2dptfX","indicatorsContainer":"_3Tsv-PlG54pXMU3VQHEJsK","flexTags":"_3VwNJFMZKXPn76TGewv-sz"};